var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"provider-info"},[_c('span',{staticClass:"provider-name"},[_vm._v("\n    Mozio\n  ")]),(_vm.category)?_c('provider-category',{attrs:{"category":_vm.category}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }